/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driver_Delivery_Paid_Toast_GenericInputs */

const vi_driver_delivery_paid_toast_generic = /** @type {(inputs: Driver_Delivery_Paid_Toast_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn giao của bạn đã nhận tiền — có thể đi đơn tiếp`)
};

/**

* @param {Driver_Delivery_Paid_Toast_GenericInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const driver_delivery_paid_toast_generic = /** @type {((inputs?: Driver_Delivery_Paid_Toast_GenericInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driver_Delivery_Paid_Toast_GenericInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driver_delivery_paid_toast_generic(inputs)
});